var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocial2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_163_188)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_163_188)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.874024 2.86674C0.874024 2.2235 1.12955 1.6066 1.58438 1.15177C2.03923 0.696934 2.65611 0.441409 3.29935 0.441409H27.476C27.7949 0.440889 28.1106 0.503247 28.4052 0.624915C28.6998 0.746581 28.9676 0.925168 29.1931 1.15045C29.4186 1.37573 29.5975 1.64329 29.7195 1.93779C29.8415 2.2323 29.9042 2.54797 29.904 2.86674V27.0434C29.9044 27.3623 29.8419 27.678 29.72 27.9727C29.5982 28.2673 29.4195 28.5351 29.1941 28.7606C28.9687 28.9861 28.7011 29.1649 28.4065 29.2869C28.112 29.4089 27.7962 29.4716 27.4774 29.4714H3.29935C2.98074 29.4714 2.66525 29.4086 2.37091 29.2867C2.07657 29.1647 1.80914 28.9859 1.58392 28.7606C1.35869 28.5352 1.18006 28.2677 1.05826 27.9733C0.936456 27.6789 0.873851 27.3633 0.874024 27.0448V2.86674ZM12.3646 11.5098H16.2956V13.4838C16.8629 12.349 18.3144 11.3277 20.4956 11.3277C24.6773 11.3277 25.6683 13.588 25.6683 17.7354V25.4178H21.4365V18.6802C21.4365 16.3182 20.8691 14.9854 19.4281 14.9854C17.429 14.9854 16.5977 16.4224 16.5977 18.6802V25.4178H12.3646V11.5098ZM5.10713 25.237H9.34022V11.3277H5.10713V25.2356V25.237ZM9.94586 6.79106C9.95389 7.1535 9.88934 7.51389 9.75619 7.85107C9.62301 8.18826 9.42382 8.49543 9.17031 8.75459C8.9168 9.01374 8.61408 9.21965 8.27991 9.36023C7.94575 9.5008 7.58687 9.57322 7.22433 9.57322C6.86181 9.57322 6.50293 9.5008 6.16876 9.36023C5.83459 9.21965 5.53187 9.01374 5.27836 8.75459C5.02485 8.49543 4.82566 8.18826 4.69247 7.85107C4.55929 7.51389 4.4948 7.1535 4.50277 6.79106C4.51844 6.07963 4.81206 5.40262 5.32074 4.90502C5.82942 4.40741 6.51274 4.12877 7.22433 4.12877C7.93593 4.12877 8.61924 4.40741 9.12793 4.90502C9.63662 5.40262 9.93028 6.07963 9.94586 6.79106Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_163_188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 29.03,
    fill: "white",
    transform: "translate(0 0.441406)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_163_188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.9977,
    height: 29.03,
    fill: "white",
    transform: "translate(0.000976562 0.441406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial2);
export default __webpack_public_path__ + "static/media/Social-2.3d1bc58814a81a52333b3b2450049efe.svg";
export { ForwardRef as ReactComponent };